import frenchFlag from "@/assets/images/french_flag.svg";
import belgiumFlag from "@/assets/images/belgium_flag.svg";
import luxembourgFlag from "@/assets/images/luxembourg_flag.svg";
import cotedivoireFlag from "@/assets/images/cotedivoire_flag.svg";

export const SERVICE_ID = "rapsotec";
export const BIMDATA_STATUS = {
  SUCCESS: "SUCCESS",
  LOADING: "LOADING",
  ERROR: "ERROR",
};

// M.G 05/08/26 Missions de la famille sécurité des personnes : l'ancien code S et
// les codes de vente Atlas qui le portent (ABAA=SH, ABAB=SEI, ABAC=STI, HBAE=RVRAT,
// HBAF=RVRMD). Les offres qui apportent S sans créer de mission propre (ABCA, HBAA,
// HBAG, HBAX) sont couvertes par S lui-même.
// Déclarée ici et pas dans utils/report pour éviter un cycle d'import
// (utils/report importe store/project).
export const SECURITY_MISSION_CODES = ["S", "ABAA", "ABAB", "ABAC", "HBAE", "HBAF"];

// M.G 02/09/26 Missions parasismiques : l'ancien code PS et les codes de vente
// Atlas qui le portent. HCDG et JABD sont des attestations parasismiques seules.
export const PARASISMIC_MISSION_CODES = ["PS", "AAAE", "HCDG", "JABD"];

// M.G 02/09/26 Missions carbone I3C : anciens codes conception / réalisation et
// les codes de vente Atlas qui les remplacent.
export const CARBON_MISSION_CODES = ["CaC", "CaR", "AZBL", "AZBM"];

export const COUNTRY_FLAG = [
  { value: "FR", image: frenchFlag },
  { value: "BE", image: belgiumFlag },
  { value: "LU", image: luxembourgFlag },
  { value: "CI", image: cotedivoireFlag },
];
